// client/src/components/account/PublicPageSettings.js - CORRIGIDO
import React from 'react';
import { useMyAccountDetails } from '../../hooks/useAccounts';
import PublicPageSettingsPanel from '../plataforma/contas/PublicPageSettingsPanel';
import { Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PublicPageSettings = () => {
    const { data: account, isLoading } = useMyAccountDetails();
    const navigate = useNavigate();

    // ✅ CORREÇÃO: Volta para página anterior
    const handleBack = () => {
        navigate(-1);
    };

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-64">
                <Loader2 className="animate-spin text-indigo-600" size={40} />
            </div>
        );
    }

    if (!account?._id) {
        return (
            <div className="p-8 text-center text-red-500">
                Erro: Nenhuma conta associada a este usuário.
            </div>
        );
    }

    return (
        // ✅ REMOVIDO: Cabeçalho duplicado - deixe apenas o PublicPageSettingsPanel
        <PublicPageSettingsPanel 
            accountId={account._id}
            onBack={handleBack}
        />
    );
};

export default PublicPageSettings;